import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getServicos, getConfiguracoes } from '../lib/supabase'
import { fmtEur } from '../lib/valores'
import { ordenarCategorias } from '../lib/categorias'
import { useTenant } from '../contexts/TenantContext'
import Loading from '../components/Loading'
import Carrossel from '../components/Carrossel'
import fotosCarrossel from '../config/carrossel'

export default function PaginaInicio() {
  const { tenant } = useTenant()
  const [servicos, setServicos] = useState([])
  const [ordemCategorias, setOrdemCategorias] = useState('')
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    if (!tenant) return
    Promise.all([getServicos(tenant.id), getConfiguracoes(tenant.id)])
      .then(([srv, cfg]) => {
        setServicos(srv)
        setOrdemCategorias(cfg.ordem_categorias || '')
      })
      .catch(console.error)
      .finally(() => setCarregando(false))
  }, [tenant])

  const categorias = ordenarCategorias(
    [...new Set(servicos.map(s => s.categoria))],
    ordemCategorias
  )

  return (
    <main>
      {/* Carrossel — só aparece se houver fotos configuradas */}
      {fotosCarrossel.length > 0 && <Carrossel fotos={fotosCarrossel} tenantNome={tenant?.nome} />}

      {/* Serviços */}
      <section style={{
        maxWidth: '1020px',
        margin: '0 auto',
        padding: 'var(--section-y) var(--pad-x)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 'clamp(40px, 7vw, 64px)' }}>
          <h2 style={{ fontSize: 'clamp(30px, 8vw, 42px)', fontWeight: '300', margin: 0 }}>
            Os Nossos Serviços
          </h2>
          <span style={{
            display: 'inline-block',
            width: '56px',
            height: '2px',
            background: 'var(--cor-ambar)',
            marginTop: '16px',
            borderRadius: '2px',
          }} />
        </div>

        {carregando ? (
          <Loading />
        ) : (
          categorias.map(cat => (
            <div key={cat} style={{ marginBottom: 'clamp(40px, 7vw, 56px)' }}>
              <h3 style={{
                fontSize: '11px',
                fontFamily: 'var(--font-base)',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.2em',
                color: 'var(--cor-ambar)',
                marginBottom: '18px',
                paddingBottom: '12px',
                borderBottom: '1px solid var(--cor-borda)',
              }}>
                {cat}
              </h3>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                gap: '12px',
              }}>
                {servicos.filter(s => s.categoria === cat).map(s => (
                  <CardServico key={s.id} servico={s} />
                ))}
              </div>
            </div>
          ))
        )}

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <Link
            to="/agendar"
            className="btn-primario"
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            Agendar Agora
          </Link>
        </div>
      </section>
    </main>
  )
}

function CardServico({ servico: s }) {
  const [ativo, setAtivo] = useState(false)

  return (
    <Link
      to="/agendar"
      state={{ servico: s }}
      className="card-servico"
      onMouseDown={() => setAtivo(true)}
      onMouseUp={() => setAtivo(false)}
      onMouseLeave={() => setAtivo(false)}
      onTouchStart={() => setAtivo(true)}
      onTouchEnd={() => setAtivo(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        minHeight: '56px',
        background: 'var(--cor-branco)',
        border: '1px solid var(--cor-borda)',
        borderRadius: 'var(--raio-lg)',
        padding: '18px 18px 18px 20px',
        boxShadow: 'var(--sombra)',
        textDecoration: 'none',
        cursor: 'pointer',
        transition: 'transform 0.15s var(--ease), box-shadow 0.15s var(--ease)',
        transform: ativo ? 'scale(0.985)' : 'none',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '10px',
          marginBottom: '6px',
        }}>
          <span style={{
            fontFamily: 'var(--font-base)',
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--cor-principal)',
            lineHeight: 1.2,
          }}>
            {s.nome}
          </span>
          <span style={{
            fontSize: '11px',
            fontFamily: 'var(--font-ui)',
            color: 'var(--cor-ambar)',
            background: 'var(--cor-creme)',
            padding: '4px 10px',
            borderRadius: '12px',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}>
            {s.duracao_real_min ?? s.duracao_min} min
          </span>
        </div>
        <p style={{
          fontSize: '13px',
          fontFamily: 'var(--font-ui)',
          color: 'var(--cor-texto-suave)',
          lineHeight: '1.55',
          margin: 0,
        }}>
          {s.descricao}
        </p>
        {Number(s.preco) > 0 && (
          <p style={{
            fontSize: '15px',
            fontFamily: 'var(--font-ui)',
            fontWeight: '600',
            color: 'var(--cor-principal)',
            margin: '8px 0 0',
          }}>
            {fmtEur(s.preco)}
          </p>
        )}
      </div>

      {/* Indicador de toque */}
      <span aria-hidden="true" style={{
        flexShrink: 0,
        color: 'var(--cor-ambar)',
        fontSize: '22px',
        lineHeight: 1,
      }}>
        →
      </span>
    </Link>
  )
}
